export const NAVIGATION_SHOW = 'NAVIGATION_SHOW';
export const NAVIGATION_HIDE = 'NAVIGATION_HIDE';
export const NAVIGATION_ENTERPRISE = 'NAVIGATION_ENTERPRISE';
export const UPDATE_LOCATION = 'updateLocation';
export const GLOBAL_DATA = 'GLOBAL_DATA';
